export default __webpack_public_path__ + "static/media/63.cf2c4c4d.jpg";